import { ApiFunction, BaseApiFunction } from "../functions/Apifunction";
import { Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const getStoredAuthToken = () =>
  localStorage.getItem("Authorization")
    ? localStorage.getItem("Authorization")
    : "";

const baseUrl = process.env.REACT_APP_GET_BASE_URL;

// toast.configure();

const options = {
  position: toast.POSITION.BOTTOM_RIGHT,
  transition: Flip,
  toastClassName: "toast",
  closeButton: false,
};

export const getNDRData = async (awb) => {
  const tok = getStoredAuthToken();
  const link = process.env.REACT_APP_GET_NDR;
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("sec-fetch-mode", "cors");
  myHeaders.append("orgId", "");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    let data = await fetch(`${link}?awb=${awb}`, requestOptions);
    return data;
  } catch (Err) {}
};
export const searchAwb = async (awb) => {
  try {
    let raw = {
      field: "shipment",
      value: awb,
    };
    let data = await ApiFunction(
      "POST",
      `${baseUrl}/api/track/`,
      JSON.stringify(raw)
    );
    return data;
  } catch (err) {
    return null;
  }
};
export const handlePostFeedback = async (ratings) => {
  try {
    let raw = ratings;
    let data = await ApiFunction(
      "POST",
      `${baseUrl}/api/track/rating`,
      JSON.stringify(raw)
    );
    return data;
  } catch (err) {
    return null;
  }
};
export const getOTP = async (awb) => {
  try {
    const raw = {
      shipmentAwb: awb,
    };
    let data = await ApiFunction(
      "POST",
      `${baseUrl}/api/track/otp/generate`,
      JSON.stringify(raw)
    );
    return data;
  } catch (Err) {
    return null;
  }
};
export const verifyOtpAndAction = async (
  reschedule,
  otpMsg,
  activeStatus,
  awb,
  orderInfo,
  moment,
  subOrderId,
  setotpPage,
  fakeAttempt
) => {
  let address = "";
  const address1 = reschedule?.address1;

  if (reschedule?.address1 !== null && reschedule?.address2 !== null) {
    if (address1?.length > 0) {
      address = reschedule?.address1 + ", " + reschedule?.address2;
    } else {
      address = reschedule?.address2;
    }
  }

  const ndrBody = {
    awbNumber: awb,
    shipmentId: -1,
    shopOrderNumber: orderInfo?.shop_order_number,
    ndrKey: "awbNumber",
    createdAt: orderInfo?.created_at,
    googleMapAddressLink: "",
    newAddress: address?.replace(/^,*/, ""),
    newContact: reschedule?.number === "" ? null : reschedule?.number,
    newName: reschedule?.name === "" ? null : reschedule?.name,
    newDate: reschedule?.date === "" ? null : reschedule?.date,
    newpin: reschedule?.pincode === "" ? null : reschedule?.pincode,
    remarks:
      reschedule?.remarks === ""
        ? "Buyer Instruction Received"
        : reschedule?.remarks,
    action: activeStatus.reschedule ? "Reattempt" : "cancel",
    ndrInitiatedBy: "Tracking-Page",
    fakeAttempt: fakeAttempt == "true" ? "true" : "false",
    proofAttachmentLink: "",
    deliveryInstruction: reschedule?.deliveryInstruction,
    reAttemptSlot: reschedule?.time,
  };

  if (reschedule?.lat && reschedule?.lng) {
    ndrBody.newLat = reschedule?.lat;
    ndrBody.newLong = reschedule?.lng;
  }

  var raw = JSON.stringify({
    shipment_awb: awb,
    otp: Object.values(otpMsg).join(""),
    action: activeStatus.reschedule ? "ndr" : "cancel",
    body: activeStatus.reschedule
      ? [
          {
            ndrRequests: [ndrBody],
          },
        ]
      : [
          {
            ndrRequests: [
              {
                field: "shipment",
                value: subOrderId,
              },
            ],
          },
        ],
  });

  let data = await ApiFunction(
    "POST",
    `${baseUrl}/api/track/otp/validate`,
    raw
  );
  console.log(data, "data");
  if (data?.status === "Success") {
    console.log("status");
    // toast.success(data.status, options);
    setotpPage(false);
    return data;
  } else {
    // toast.error(data.status, options);
    return data;
  }
};

export const verifyOtpActionForEdit = async (otpMsg, awb, setotpPage) => {
  try {
    var raw = JSON.stringify({
      shipment_awb: awb,
      otp: otpMsg != null ? Object.values(otpMsg).join("") : null,
      action: "full-details",
      body: [
        {
          field: "shipment",
          value: awb,
        },
      ],
    });

    let data = await ApiFunction(
      "POST",
      `${baseUrl}/api/track/otp/validate`,
      raw
    );

    if (data?.status === "Success" || data?.result?.code === "200") {
      if (setotpPage) {
        setotpPage(false);
      }
      return data;
    } else {
      return data;
    }
  } catch (error) {
    //
  }
};
export const verifyOtpActionForDelivery = async (otpMsg, awb, action) => {
  var raw = JSON.stringify({
    shipment_awb: awb,
    otp: Object.values(otpMsg).join(""),
    action: "delivery-otp",
    body: [],
  });
  let data = await ApiFunction(
    "POST",
    `${baseUrl}/api/track/otp/validate`,

    raw
  );

  if (data?.status === "Success" || data?.result === "200" || data?.code == "200") {
    sessionStorage.setItem("deliveryotp", JSON.stringify(data.result));
    sessionStorage.setItem("delivery-otp", true);

    return data;
  } else {
    return data;
  }
};

export const fetchLocation = async (pincode) => {
  const tok = getStoredAuthToken();
  const getAreaInfo = process.env.REACT_APP_GET_AUTOFILL_PINCODE_URL;
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", tok);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  let queryParams = "pincode__in=" + pincode;
  let getAreaInfoFromPincode =
    getAreaInfo + new URLSearchParams(queryParams).toString();
  const res = await fetch(getAreaInfoFromPincode, requestOptions);
  const p_data = await res.json();
  console.log("p_data", p_data);
  return p_data;
};

export const customerapieditdata = async (customerData, awb) => {
  console.log("customerData", customerData);

  const postcustomerinfo = `${baseUrl}/api/track/otp/validate`;
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    shipment_awb: awb,
    otp: JSON.parse(sessionStorage.getItem("otp")),
    action: "edit",
    body: [
      {
        ndrRequests: [
          {
            awbNumber: awb,
            newAddress:
              customerData.address === "" ? null : customerData.address,
            newContact: customerData.number === "" ? null : customerData.number,
            newName: customerData.name === "" ? null : customerData.name,
            newDate: customerData.date === "" ? null : customerData.date,
            newpin: customerData.pincode === "" ? null : customerData.pincode,
            newEmail: null,
            remarks: "Buyer Instruction Received",
            action: "Add-Address",
            ndrInitiatedBy: "Tracking-Page",
          },
        ],
      },
    ],
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const res = await fetch(postcustomerinfo, requestOptions);
  return res;
};

export const getCodCallingData = async (awb) => {
  const getCODCallinglink = process.env.REACT_APP_GET_BASE_URL;
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  const requestOption = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };

  try {
    let res = await fetch(
      `${getCODCallinglink}cod/details/teams/${awb}`,
      requestOption
    );
    console.log("res", res);
    let data = await res.json();
    return data;
  } catch (e) {
    console.log(e);
  }
};

export const validateAndSubmitNdr = async ({
  awbNumber,
  newAddress,
  newContact,
  newName,
  newPin,
  otp,
  lat,
  lng,
  shopOrderNumber, //* From order details
  createdAt, //* From order details
}) => {
  try {
    const body = {
      awbNumber,
      shipmentId: -1,
      shopOrderNumber: shopOrderNumber,
      ndrKey: "awbNumber",
      createdAt: createdAt,
      googleMapAddressLink: "",
      newAddress: newAddress?.replace(/^,*/, ""),
      newContact: newContact,
      newName: newName,
      newDate: null, //* Confirm with backend *//
      newpin: newPin,
      remarks: "Buyer Instruction Received", //* Confirm with backend *//
      action: "Reattempt",
      ndrInitiatedBy: "Tracking-Page",
      fakeAttempt: "false",
      proofAttachmentLink: "",
      deliveryInstruction: "", //* Confirm with backend *//
      reAttemptSlot: "", //* Confirm with backend *//
    };

    if (lat && lng) {
      body.newLat = lat;
      body.newLong = lng;
    }

    const raw = JSON.stringify({
      shipment_awb: awbNumber,
      otp: otp,
      action: "ndr",
      body: [
        {
          ndrRequests: [body],
        },
      ],
    });

    const apiData = await BaseApiFunction({
      endpoint: `/api/track/otp/validate`,
      method: "POST",
      body: raw,
    });

    return apiData;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.toString(),
      dataL: null,
    };
  }
};

export const validateAndCancel = async ({ awb, otp, subOrderId }) => {
  try {
    const body = {
      shipment_awb: awb,
      otp: otp,
      action: "cancel",
      body: [
        {
          ndrRequests: [
            {
              field: "shipment",
              value: subOrderId,
            },
          ],
        },
      ],
    };

    const raw = JSON.stringify(body);

    const apiData = await BaseApiFunction({
      endpoint: `/api/track/otp/validate`,
      method: "POST",
      body: raw,
    });

    return apiData;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.toString(),
      dataL: null,
    };
  }
};
